<!-- PrimeNG Dialog -->
<p-dialog [(visible)]="displayDialog" [style]="{ width: '400px', height: '250px' }"
    [contentStyle]="{ 'text-align': 'center', 'padding': '1rem' }" [modal]="true" [closable]="false"
    [showHeader]="false" contentStyle="text-align: center; padding: 2rem; border-radius: 8px;">
    <!-- Success Dialog -->
    @if (isSuccess) {
    <div>
        <i class="pi pi-check-circle" style="font-size: 4rem; color: green;"></i>
        <h2 style="margin-top: 1rem;">Gracias, Tu Ejecutivo ha sido asignado</h2>
        <h3 style="font-weight: bold; display: none;">{{ description }}</h3>
    </div>
    }

    <!-- Error Dialog -->
    @if (!isSuccess) {
    <div>
        <i class="pi pi-times-circle" style="font-size: 4rem; color: red;"></i>
        <h3 style="margin-top: 1rem;">
            Aún no eres cliente<br />
            regístrate en el siguiente formulario
        </h3>
    </div>
    }
</p-dialog>

<!-- Buttons to test -->
<!-- <div style="text-align: center; margin-top: 2rem;">
    <button pButton type="button" label="Mostrar Éxito" class="p-button-success" (click)="openDialog(true)"></button>
    <button pButton type="button" label="Mostrar Error" class="p-button-danger" (click)="openDialog(false)"
        style="margin-left: 1rem;"></button>
</div> -->